<div class="user-indicator-container" [class]="'layout-' + layout()">
  <div class="user-indicator">
    @if (isThreadOpen()) {
      <div class="follow-toggle">
        <alg-switch class="small-switch"
          [ngModel]="followStatus().data ?? false"
          [class.disabled]="!followStatus().isReady"
          (change)="onFollowChange($event)"
         />
        @if (followStatus().data) {
          <span class="follow-label" i18n>You currently follow this thread</span>
        } @else {
          <span class="follow-label" i18n>You currently do not follow this thread</span>
        }
      </div>
    }
  </div>
</div>
